import { ObjectElementFactory } from "../ObjectElementFactory";
import { ElementRegistry } from "../ElementRegistry";
import { ImgElement } from "./ImgElement";
/**
 * Img Element Factory
 */
export class ImgElementFactory extends ObjectElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    createElement(htmlElement, bindData, context) {
        return new ImgElement(htmlElement, bindData, context);
    }
}
/**
 * Static block
 */
(() => {
    // register factory instance
    ElementRegistry.register('img', new ImgElementFactory());
})();
//# sourceMappingURL=ImgElementFactory.js.map